import API_URLS, {
  AWS_EU_CENTRAL_1,
  AWS_US_WEST_2,
  GCP_US_CENTRAL_1,
} from '@src/api/urls.ts';

export enum CollectionOwner {
  USER = 'Me',
  SHARED = 'Shared with me',
  SANDBOX = 'Sandbox',
}

export enum CollectionOwnerFilter {
  ANY = 'Any',
  USER = CollectionOwner.USER,
  SHARED = CollectionOwner.SHARED,
}

export enum ByocLayerSubtype {
  BYOC = 'BYOC',
  ZARR = 'ZARR',
}

export enum SampleFormat {
  UINT = 'UINT',
  INT = 'INT',
  FLOAT = 'FLOAT',
}

export const BYOC_LOCATION_CONFIG = Object.fromEntries(
  Object.entries(API_URLS.regions).filter(([key]) =>
    [AWS_EU_CENTRAL_1, AWS_US_WEST_2].includes(key),
  ),
);

export const ZARR_LOCATION_CONFIG = Object.fromEntries(
  Object.entries(API_URLS.regions).filter(([key]) =>
    [AWS_EU_CENTRAL_1, AWS_US_WEST_2].includes(key),
  ),
);

export const LOCATION_NAMES: {[s: string]: string} = {
  [AWS_EU_CENTRAL_1]: 'AWS EU (Frankfurt)',
  [AWS_US_WEST_2]: 'AWS US West (Oregon)',
  [GCP_US_CENTRAL_1]: 'GCP US Central',
};

export function locationToBaseUrl(location: string): string | undefined;
export function locationToBaseUrl(
  config: Record<string, string | undefined>,
): Record<string, string>;
export function locationToBaseUrl(
  arg: string | Record<string, string | undefined>,
): string | undefined | Record<string, string> {
  if (typeof arg === 'string') {
    return API_URLS.regions[arg as keyof typeof API_URLS.regions];
  }
  return Object.fromEntries(
    Object.entries(arg).filter(([, v]) => v !== undefined),
  ) as Record<string, string>;
}

export const PLANET_BUCKETS = [
  'planet.com',
  'sh.subscriptions.byoc.eu-central-1',
  'pip-subscriptions-byoc-us-central1-prod',
  'sh-staging0-eu-central-1-byoc-subscriptions',
  'pip-prod-us-1-subscriptions',
  'planet-prod-ppc',
];

export const STAC_COLLECTION_ID_PREFIX = {
  [ByocLayerSubtype.BYOC]: 'byoc-',
  [ByocLayerSubtype.ZARR]: 'zarr-',
};

export enum SelectedDataCollectionTab {
  DETAILS = 'DETAILS',
  TILES = 'TILES',
  ARRAYS = 'ARRAYS',
  CONFIGURATIONS = 'CONFIGURATIONS',
}

export const PLANET_SANDBOX_COLLECTION_IDS: string[] = [
  '3f605f75-86c4-411a-b4ae-01c896f0e54e',
  '9ff30ab7-62c2-4d19-b5ef-83805c7e7602',
  'f3312c82-edea-42a1-8c9d-ada86ddcc857',
  'e3d2a21c-cb75-4311-86ac-024385c85b9c',
  'cc31cada-80d8-46fe-a746-43ac2f87b5da',
  '6b613b07-410a-4312-93ad-d1751fdc55de',
  '858254ae-0f29-4152-ac53-449efa00bbb0',
  'c48c018f-67a1-4827-a1e4-f3ab98690312',
  '28eef896-9632-4546-a99e-cea34d74b21e',
  'fc704520-fc81-439f-9016-5e162c32e736',
  'd09d8fd8-a3b3-49fb-9d78-47f3a5cc8ecc',
  'ca501757-cf8e-43a8-b1a4-1aa59ae22425',
  'd4a2a179-0c1a-4426-8d54-e2ac82830e83',
];

export enum DataCollectionFilter {
  planet = 'planet',
  publicData = 'publicData',
  byocZarr = 'byocZarr',
  sandboxData = 'sandboxdata',
  tpdi = 'tpdi',
}

export enum CollectionDataProvider {
  planet = 'planet',
  other = 'other',
}
